module.exports = __webpack_public_path__ + "static/media/logo.3bfdc9d3.png";